import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/auth/";

class AuthService {
  login(email, password, rememberMe = false) {
    return axios
      .post(API_URL + "signin", {
        email,
        password,
        rememberMe,
      })
      .then((response) => {
        if (response.data.accessToken) {
          console.log("access token created " + response.data.accessToken);
          // localStorage persists across browser restarts; combined with the
          // backend issuing a 30-day JWT when rememberMe=true, this keeps the
          // user signed in for a month. Without remember-me, JWT expires after 24h.
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password,
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }
}

export default new AuthService();
